import React from 'react';
import { Dropdown, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import FalconCloseButton from 'components/common/FalconCloseButton';
import { getText } from 'function/language';

/**
 * 검색
 */
const Search = ({ datas, placeholder, readOnly, value, setValue, onKeyUp }) => (
  <Dropdown className="search-box w-auto" onSelect={setValue}>
    <Dropdown.Toggle as="div" bsPrefix="toggle" size="sm">
      <Form className="position-relative">
        <Form.Control
          readOnly={readOnly}
          size="sm"
          type="search"
          value={value}
          className="search-input rounded-0 lh-base"
          placeholder={getText(placeholder) ?? placeholder}
          onChange={({ target: { value } }) => {
            setValue(value);
          }}
          onKeyUp={onKeyUp}
        />
        <FontAwesomeIcon
          icon="search"
          className="position-absolute text-400 search-box-icon"
        />
        {value && (
          <div
            className="search-box-close-btn-container"
            style={{ top: '4px' }}
          >
            <FalconCloseButton
              size="sm"
              noOutline
              onClick={() => {
                setValue('');
              }}
            />
          </div>
        )}
      </Form>
    </Dropdown.Toggle>
    {!readOnly && (
      <Dropdown.Menu>
        <div className="scrollbar" style={{ maxHeight: '10rem' }}>
          {datas
            .filter(
              ({ text } = {}) =>
                !value || text.toLowerCase().includes(value.toLowerCase())
            )
            .map(({ text, value } = {}, index) => (
              <Dropdown.Item
                key={`datas${index}`}
                eventKey={value}
                className="fs--0 px-card py-1 hover-primary"
              >
                {text}
              </Dropdown.Item>
            ))}
        </div>
      </Dropdown.Menu>
    )}
  </Dropdown>
);

Search.propTypes = {
  // 목록
  datas: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  ),

  // 힌트
  placeholder: PropTypes.string,

  // 읽기 전용 여부
  readOnly: PropTypes.bool,

  // 값
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  // 값 설정 함수
  setValue: PropTypes.func,

  // 키 입력 시 이벤트
  onKeyUp: PropTypes.func
};
Search.defaultProps = {
  datas: [],
  readOnly: false
};

export default Search;
